// Icons
import GCBImage from "assets/images/glory/gcb.avif";
import Mastercard from "../assets/icons/glory/payment_mastercard.svg?react";
import Visa from "../assets/icons/glory/payment_visa.svg?react";
import Rgc from "../assets/images/glory/partners_rgc.svg?react";
import BeGamble from "../assets/images/glory/partners_begamble.svg?react";
import BeGambleBanger from "../assets/images/glory/partners_begamble_banger.svg?react";
import Age from "../assets/images/glory/age_logo.svg?react";

export enum FOOTER_PARTNERS_ENUMS {
  BKASH,
  NAGAD,
  PAYTM,
  PHONEPE,
  ROCKET,
  MASTERCARD,
  VISA,
  GAMINGC,
  RGC,
  BEGAMBLE,
  AGE,
  GCB,
}

export type FooterPaymentsType = {
  id: number;
  icon: JSX.Element;
};

export const FOOTER_PAYMENTS: FooterPaymentsType[] = [
  {
    id: FOOTER_PARTNERS_ENUMS.MASTERCARD,
    icon: <Mastercard />,
  },
  {
    id: FOOTER_PARTNERS_ENUMS.VISA,
    icon: <Visa />,
  },
];

export type FooterPartnersType = {
  id: number;
  icon?: JSX.Element;
  image?: string;
  link: string;
};
const { VITE_APP_PROJECT_NAME } = import.meta.env;

export const FOOTER_PARTNERS: FooterPartnersType[] = [
  // {
  //     id: FOOTER_PARTNERS_ENUMS.GAMINGC,
  //     icon: VITE_APP_PROJECT_NAME === 'glory' ? <GamingCuracao /> : <GamingCuracaoBanger />,
  //     link: '',
  // },
  {
    id: FOOTER_PARTNERS_ENUMS.RGC,
    icon: <Rgc />,
    link: "https://www.responsiblegambling.org/",
  },
  {
    id: FOOTER_PARTNERS_ENUMS.BEGAMBLE,
    icon: VITE_APP_PROJECT_NAME === "glory" ? <BeGamble /> : <BeGambleBanger />,
    link: "https://www.begambleaware.org/",
  },
  {
    id: FOOTER_PARTNERS_ENUMS.AGE,
    icon: <Age />,
    link: "",
  },
  {
    id: FOOTER_PARTNERS_ENUMS.GCB,
    image: GCBImage,
    link:
      VITE_APP_PROJECT_NAME === "glory"
        ? "https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJazV4S3pneFpGcHNZVnBzUzJsQ1ZUTkNkM0p3V2tFOVBTSXNJblpoYkhWbElqb2lVa05xZHpNMEt6QjVSekI1THpoT1EzZDFNaXN4WnowOUlpd2liV0ZqSWpvaU5XUTBaV1pqTVdJd05ESXhNRGMwWWpBNVpqUmxORGd5Wm1GbE9ESmxPV0kyT1RVMFlXTTRZekl6TmpZME5ETXpORGN6TURVMFpHUmtOMkZsTURoak5DSXNJblJoWnlJNklpSjk="
        : "https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJbEI1T0RKRmVXMVJUSE5MYUU1T1dFdHpXVXhWV0VFOVBTSXNJblpoYkhWbElqb2lWR2RXY1U1R2RtMW5LMVJwTDJkdllqUlFRalZtZHowOUlpd2liV0ZqSWpvaU9XWXdNVGhsWkRrMFl6QTVNMkZqTWpJeVpXSmtPR1JpTkRsbFpqRm1aVEk0WTJJd05XUmpOVFZrTTJRek5UZ3lOakJtTmpnd1l6TTNOREV6TXprM01pSXNJblJoWnlJNklpSjk=",
  },
];

const amatic = `https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/amatic${
  VITE_APP_PROJECT_NAME === "banger" ? `_${VITE_APP_PROJECT_NAME}` : ""
}.svg`;

export const INFO_PARTNER_LIST = [
  { id: 1, icon: amatic, title: "Amatic" },
  {
    id: 2,
    icon: "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/endorphina.svg",
    title: "Endorphina",
  },
  {
    id: 3,
    icon: "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/red_tiger_premium.svg",
    title: "Red Tiger",
  },
  {
    id: 4,
    icon: "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/platipus.svg",
    title: "Platipus",
  },
  {
    id: 5,
    icon: "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/netgame.svg",
    title: "Netgame",
  },
  {
    id: 6,
    icon: "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/gamanza.svg",
    title: "Gamanza",
  },
  {
    id: 7,
    icon: "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/playson.svg",
    title: "Playson",
  },
  {
    id: 8,
    icon: "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/microgaming.svg",
    title: "Microgaming",
  },
  {
    id: 9,
    icon: "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/tomhorn.svg",
    title: "Tomhorn",
  },
  {
    id: 10,
    icon: "https://diswdgcu9cfva.cloudfront.net/providers_logo/mini/turbogames.svg",
    title: "Turbogames",
  },
  { id: 11, icon: "info.providers.number", title: "info.providers.title" },
];
